import { v4 as guid } from 'uuid'

const PERFORMANCE_LOGS = false

const now = () => Date.now()

export default (ctx) => {
  const req = ctx.app.$req
  const id = guid()

  if (process.server && PERFORMANCE_LOGS) {
    console.time = (label: string) => {
      req.timers.set(`${label}-${id}`, now())
    }

    console.timeEnd = (label: string) => {
      const start = req.timers.get(`${label}-${id}`)
      if (start != null) {
        const ms = Math.round(now() - start)

        console.log(`time: '${label}' took ${ms}ms`)
        req.timers.delete(`${label}-${id}`)
      } else {
        console.warn(`label '${label}' with id ${id} doesn't exist`)
      }
    }
  }
}
